import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
    // container: {
    //     height: '50%',
    //     display: 'flex',
    //     flexDirection: 'column'
    // },
    headerStack: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: theme.spacing(0.25, 1)
    },
    iconColor: {
        color: theme.palette.text.secondary
    },
    scrollBox: {
        width: '100%',
        flex: 1,
        overflowY: 'auto'
    },
    emptyAlertContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        color: theme.palette.text.secondary
    }
}))